
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uh-oh",
      function () {
        return require("private-next-pages/uh-oh.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/uh-oh"])
      });
    }
  